
import classNames from 'classnames';
import React, { Component } from 'react';

export default class Icon extends Component {

  render() {

    const {
      className,
      name,
      onClick,
    } = this.props;

    return (
      <span
        onClick={onClick}
        className={classNames(className, {
          'icon': true,
          [`icon-${name}`]: true,
          'fa': true,
          [`fa-${name}`]: true,
        })}
      />
    );

  }

}



// WEBPACK FOOTER //
// ./client/components/Icon.jsx